import React, { useState } from 'react';
import styled from 'styled-components';
import { FaTimes, FaSearch } from 'react-icons/fa';

const SearchContainer = styled.div`
  width: 300px;
  background-color: #f7f7f7;
  border-left: 1px solid #ddd;
  display: flex;
  flex-direction: column;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 100;
  box-shadow: -2px 0 5px rgba(0,0,0,0.1);
`;

const SearchHeader = styled.div`
  padding: 15px;
  background-color: white;
  border-bottom: 1px solid #ddd;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: bold;
`;

const SearchContent = styled.div`
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow-y: auto;
  flex: 1;
`;

const SearchInputContainer = styled.div`
  display: flex;
  gap: 5px;
`;

const SearchInput = styled.input`
  flex: 1;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  outline: none;
`;

const SearchButton = styled.button`
  padding: 8px 12px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  
  &:hover {
    background-color: #0056b3;
  }
`;

const ResultItem = styled.div`
  background: white;
  padding: 10px;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  font-size: 0.9em;
  cursor: pointer;
  
  &:hover {
    background-color: #f0f0f0;
  }
`;

const ResultHeader = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  font-size: 0.8em;
  color: #666;
`;

const ResultContent = styled.div`
  color: #333;
`;

const SenderName = styled.span`
  font-weight: bold;
  color: #000;
`;

const SearchComponent = ({ onClose, onSearch, results, isLoading }) => {
  const [query, setQuery] = useState('');

  const handleSearch = () => {
    if (query.trim()) {
      onSearch(query);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <SearchContainer>
      <SearchHeader>
        Search Messages
        <FaTimes onClick={onClose} style={{ cursor: 'pointer' }} />
      </SearchHeader>
      <SearchContent>
        <SearchInputContainer>
          <SearchInput
            placeholder="Search..."
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={handleKeyDown}
          />
          <SearchButton onClick={handleSearch}>
            <FaSearch />
          </SearchButton>
        </SearchInputContainer>

        {isLoading && <div>Loading...</div>}

        {!isLoading && results.length === 0 && query && (
          <div style={{ textAlign: 'center', marginTop: '20px', color: '#888' }}>
            No results found
          </div>
        )}

        {results.map((msg) => (
          <ResultItem key={msg.id}>
            <ResultHeader>
              <SenderName>{msg.sender_name || 'User'}</SenderName>
              <span>{new Date(msg.created_at).toLocaleString()}</span>
            </ResultHeader>
            <ResultContent>
              {msg.content}
            </ResultContent>
          </ResultItem>
        ))}
      </SearchContent>
    </SearchContainer>
  );
};

export default SearchComponent;
